<template>
  <div class="commodityitem">
    <v-saveprice
      v-if="product.max_discount&&product.max_discount!=0"
      :saveprice="product.max_discount"
    ></v-saveprice>
    <a :href="'/products/'+product.slug" class="thumbnail product_card_backgorund">
      <v-lazy-img
        data-sizes="auto"
        :src="product.feature_image?product.feature_image.thumbnail:defaultImage"
        :data-url="product.feature_image?product.feature_image.url:defaultImage"
        class="lazyload"
        @error.once="imageFailure($event,defaultImage)"
      />
      <v-custom-button  v-if="custom_button&&custom_button.is_card=='1'" model="is_card" :custom_button='custom_button'></v-custom-button>
      <span class="fallback-text page_text_font">{{product.post_title}}</span>
    </a>
    <a :href="'/products/'+product.slug" class="intro text_font">
      <span class="intro_name page_text_font">{{product.post_title}}</span>
      <p style="display:inline-block">
        <!-- <span class="iconfont icon-jian"></span> -->
        <v-selectprice :price="product.min_price" :disable_select="!(showCurrencySelector && currencySelectorType == 'global')" :appendToBody="false"></v-selectprice>
        <!-- <span class="iconfont icon-jia"></span> -->
      </p>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ["product",'custom_button'],
  data() {
    return {
      // defaultImage
    };
  },
  mounted() {
    console.log(this.product);
  },
  computed:{
    ...mapState({
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector,
      currencySelectorType: ({ options }) => options?.theme?.global?.currency_selector_type
    })
  },
};
</script>
<style scoped lang='scss'>
.commodityitem {
  position: relative;
  .thumbnail {
    position: relative;
    width: 100%;
    height: 309px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f9f1e6;
    padding: 20px;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
    &:hover {
      opacity: 0.9;
    }
  }
  .intro {
    display: block;
    text-decoration: none;
    text-align: center;
    color: black;
    font-size: 1.2em;
    padding-top: 13px;
    margin-bottom: 15px;
    padding-bottom: 15px;
    p {
      margin: 0;
      display: inline-block;
      span {
        font-size: 14px;
        color: black;
        font-weight: 600;
      }
    }
  }
}
</style>
